import { jsx as s, Fragment as d } from "react/jsx-runtime";
import { memo as S, useCallback as h } from "react";
import y from "./SingleLimitSelector.js";
const j = S(function({
  value: t,
  onChange: l,
  configurations: p
}) {
  const f = h((e, m) => {
    const c = t ?? [];
    l == null || l(c.slice(0, m).concat([{
      ...e,
      isDefault: !1
    }], c.slice(m + 1)));
  }, [l, t]);
  return t && t.length === p.length ? /* @__PURE__ */ s(d, { children: p.map((e, m) => {
    var c;
    return (c = e.default) != null && c.enabled ? /* @__PURE__ */ s(
      y,
      {
        value: t == null ? void 0 : t[m],
        multiple: p.length > 1,
        mandatory: e.mandatory,
        affect: e.affect,
        displaySlicerOtherOption: e.displaySlicerOtherOption,
        onSortChange: (r) => f(r, m)
      },
      e.affect
    ) : /* @__PURE__ */ s(d, {});
  }) }) : /* @__PURE__ */ s(d, {});
});
export {
  j as default
};
//# sourceMappingURL=LimitsSelector.js.map
